import {
  parseMaterialDetailsResponse,
  type MaterialMasterOption,
} from '@/utils/materialMaster'
import { getActiveRegionClients } from '@/utils/regionApi'

/**
 * Material master for Engine SKU tagging (SAP CPI P4/I130 via Adonis).
 * Uses the active region BE; when Global, prefers India.
 */
export const materialMasterService = {
  async fetchMaterialDetails(customerCode = ''): Promise<MaterialMasterOption[]> {
    const clients = getActiveRegionClients()
    const preferred = clients.find((c) => c.region === 'IN') ?? clients[0]
    const { data } = await preferred.client.post<unknown>('/Fetch_MaterialDetails', {
      Request_Data: { CustomerCode: customerCode.trim() },
    })
    return parseMaterialDetailsResponse(data)
  },
}
